var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletesmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7205_18824)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.6231,
    height: 22.6231,
    rx: 11.3115,
    fill: "#FEFEFE",
    stroke: "#70706F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4452 5.54646C9.80908 5.54646 9.29344 6.0621 9.29344 6.69817V6.80287H7.30412C6.66805 6.80287 6.15241 7.31851 6.15241 7.95458V8.58278C6.15241 9.21886 6.66805 9.73449 7.30412 9.73449H7.40883V17.3777C7.40883 18.0137 7.92446 18.5294 8.56053 18.5294H15.4708C16.1069 18.5294 16.6225 18.0137 16.6225 17.3777V9.73449H16.7272C17.3633 9.73449 17.8789 9.21886 17.8789 8.58278V7.95458C17.8789 7.31851 17.3633 6.80287 16.7272 6.80287H14.7379V6.69817C14.7379 6.0621 14.2222 5.54646 13.5862 5.54646H10.4452ZM13.6909 6.69817V6.80287H10.3405V6.69817C10.3405 6.64034 10.3873 6.59347 10.4452 6.59347H13.5862C13.644 6.59347 13.6909 6.64034 13.6909 6.69817ZM7.30412 7.84988H9.50284H9.81695H14.2144H14.5285H16.7272C16.785 7.84988 16.8319 7.89675 16.8319 7.95458V8.58278C16.8319 8.64061 16.785 8.68748 16.7272 8.68748H16.4131H16.099H7.93233H7.61823H7.30412C7.2463 8.68748 7.19942 8.64061 7.19942 8.58278V7.95458C7.19942 7.89675 7.2463 7.84988 7.30412 7.84988ZM8.45583 9.73449H15.5755V17.3777C15.5755 17.4355 15.5286 17.4824 15.4708 17.4824H8.56053C8.50271 17.4824 8.45583 17.4355 8.45583 17.3777V9.73449Z",
    fill: "#70706F",
    stroke: "#70706F",
    strokeWidth: 0.418804
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9246 6.40723C10.462 6.40723 10.0869 6.78224 10.0869 7.24483V7.7537H7.66366C7.46541 7.7537 7.30469 7.91442 7.30469 8.11268V8.47165C7.30469 8.66991 7.46541 8.83063 7.66366 8.83063H16.279C16.4773 8.83063 16.638 8.66991 16.638 8.47165V8.11268C16.638 7.91442 16.4773 7.7537 16.279 7.7537H13.9459V7.24483C13.9459 6.78224 13.5709 6.40723 13.1083 6.40723H10.9246Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7205_18824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.1231,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletesmall);
export default __webpack_public_path__ + "static/media/deletesmall.15deb4da.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeletesmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7205_18824)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.6231,
    height: 22.6231,
    rx: 11.3115,
    fill: "#FEFEFE",
    stroke: "#70706F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4452 5.54646C9.80908 5.54646 9.29344 6.0621 9.29344 6.69817V6.80287H7.30412C6.66805 6.80287 6.15241 7.31851 6.15241 7.95458V8.58278C6.15241 9.21886 6.66805 9.73449 7.30412 9.73449H7.40883V17.3777C7.40883 18.0137 7.92446 18.5294 8.56053 18.5294H15.4708C16.1069 18.5294 16.6225 18.0137 16.6225 17.3777V9.73449H16.7272C17.3633 9.73449 17.8789 9.21886 17.8789 8.58278V7.95458C17.8789 7.31851 17.3633 6.80287 16.7272 6.80287H14.7379V6.69817C14.7379 6.0621 14.2222 5.54646 13.5862 5.54646H10.4452ZM13.6909 6.69817V6.80287H10.3405V6.69817C10.3405 6.64034 10.3873 6.59347 10.4452 6.59347H13.5862C13.644 6.59347 13.6909 6.64034 13.6909 6.69817ZM7.30412 7.84988H9.50284H9.81695H14.2144H14.5285H16.7272C16.785 7.84988 16.8319 7.89675 16.8319 7.95458V8.58278C16.8319 8.64061 16.785 8.68748 16.7272 8.68748H16.4131H16.099H7.93233H7.61823H7.30412C7.2463 8.68748 7.19942 8.64061 7.19942 8.58278V7.95458C7.19942 7.89675 7.2463 7.84988 7.30412 7.84988ZM8.45583 9.73449H15.5755V17.3777C15.5755 17.4355 15.5286 17.4824 15.4708 17.4824H8.56053C8.50271 17.4824 8.45583 17.4355 8.45583 17.3777V9.73449Z",
    fill: "#70706F",
    stroke: "#70706F",
    strokeWidth: 0.418804
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9246 6.40723C10.462 6.40723 10.0869 6.78224 10.0869 7.24483V7.7537H7.66366C7.46541 7.7537 7.30469 7.91442 7.30469 8.11268V8.47165C7.30469 8.66991 7.46541 8.83063 7.66366 8.83063H16.279C16.4773 8.83063 16.638 8.66991 16.638 8.47165V8.11268C16.638 7.91442 16.4773 7.7537 16.279 7.7537H13.9459V7.24483C13.9459 6.78224 13.5709 6.40723 13.1083 6.40723H10.9246Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7205_18824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.1231,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletesmall);
export default __webpack_public_path__ + "static/media/deletesmall.15deb4da.svg";
export { ForwardRef as ReactComponent };